<template>
	<div class="full" style="background-color: white;">
		<el-container class="full">
			<el-aside width="250px" style="border-right: 1px solid #DCDFE6;">
				<emun-tree :field="name" ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-aside>
			<el-container class="full flex"
				style="position: relative;flex-direction: column;box-sizing: border-box;padding: 20px;">
				<el-header class="bread" style="position: relative;height: 30px;">
					<el-breadcrumb separator-class="el-icon-arrow-right" v-if="parentbread.length!=0">
						<el-breadcrumb-item v-for="(item,index) in parentbread" :key="index">{{item.name + '【'+(item.code?item.code:"")+'】'}}
						</el-breadcrumb-item>
					</el-breadcrumb>
					<div v-else></div>
				</el-header>
				<el-main style="flex: 1;position: relative;" v-loading="loading">
					<div style="width: 100%;">
						<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
							<el-tab-pane label="外部信息" name="baseinfo">
								<baseinfo ref="baseinfo" v-if="emunid!=0" :emunid="emunid" />
							</el-tab-pane>
						</el-tabs>
					</div>
				</el-main>
				<div style="width: 100%;">
					<el-button style="float: right;" type="success" @click="onSubmit" size="mini">保存</el-button>
				</div>
			</el-container>
		</el-container>
	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	import baseinfo from './baseinfo.vue'
	export default {
		name: 'emunextend_collectionaccountIndex',
		props: {
			name: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				activeName: 'baseinfo',
				loading: false,
				currentitem: null,
				emunid: 0,
				emuntTreeKey: Math.random(),
				parentbread: [],
			}
		},
		watch: {
			emunid() {
				this.get()
			}
		},
		created() {
			let field = []
			for (let i in this.attr) {
				field.push(i)
			}
			if (field.length != 0) {
				this.$api.emunlist.list({
					field: field.join(',')
				}).then((res) => {
					res.forEach((item) => {
						this.attr[item.field].push(item)
					})
				})
			}
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			get() {
				if (!this.emunid) {
					//this.$message.error('请选择商品')
					return
				}
				this.loading = true
				this.$api.emunextend_collectionaccount.get(this.emunid).then((res) => {
					this.loading = false
					if (res) {
						this.$refs.baseinfo.form.wlnid = res.wlnid
						this.$refs.baseinfo.form.wlnname = res.wlnname
						this.$refs.baseinfo.form.account = res.account
					} else {
						this.$refs.baseinfo.form.wlnid = null
						this.$refs.baseinfo.form.wlnname = null
						this.$refs.baseinfo.form.account = null
					}

				})
			},
			emuntTreeChange(e) {
				console.log(e)
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
			onSubmit() {
				if(!this.emunid){
					this.$message.error('请选择账号')
					return
				}
				let baseinfoform = this.$refs.baseinfo.form
				let form = {
					...baseinfoform
				}
				console.log(form)
				form.emunvalueid = this.emunid
				this.$api.emunextend_collectionaccount.save(form).then(() => {
					this.$message.success('操作成功')
				})
			}
		},
		components: {
			emunTree,
			baseinfo
		}
	}
</script>